/**
 * Formats a dollar amount for API dashboard display: always two decimal places (e.g. $82.25).
 */
export function formatUsd(value: number | string | null | undefined): string {
  const n = typeof value === 'number' ? value : Number(value);
  const safe = Number.isFinite(n) ? n : 0;
  return `$${safe.toFixed(2)}`;
}
